/**
 * Sprint 71 — Cuántos pasos de la guía faltan.
 *
 * Lo necesitan dos pantallas: la guía misma y el aviso "¿Sabías que…?" del tablero. Vive aquí para
 * que la cuenta sea **una sola**: si el aviso dijera "te faltan 3" y la guía mostrara 2 en gris, el
 * operador dejaría de creerle a los dos.
 *
 * Los necesarios para poder vender son **productos y mesas**. Categorías, paquetes, promociones e
 * impresora son opcionales a propósito —un negocio puede vender sin combos, sin grupos de botones y
 * cobrar sin térmica— y por eso no cuentan como pendientes: sumarlos haría que la guía nunca se
 * pusiera en verde y el aviso no se apagara jamás.
 *
 * **Sprint 82 — el inventario salió de la cuenta, y era obligatorio que saliera.** Antes se pedía
 * capturar los ingredientes ANTES que los productos, porque el producto tenía que engancharse a uno
 * ya existente. Con el alta nueva es al revés: dar de alta "Lomo de Cerdo" **crea** su ingrediente
 * con lo que hay y su merma. Si alguien siguiera el orden viejo, el sistema le contestaría "ya
 * tienes Lomo de Cerdo en tu inventario" en el primer producto — la guía estaría enseñando a
 * chocar contra una pared.
 */
export async function contarPasosPendientes(): Promise<number> {
  try {
    const [productos, mesas] = await Promise.all([
      window.api.productos.listar(),
      window.api.mesas.listar(),
    ]);
    const hechos = [
      productos.ok && productos.data.length > 0,
      mesas.ok && mesas.data.length > 0,
    ];
    return hechos.filter((h) => !h).length;
  } catch {
    /**
     * Sin datos no se puede afirmar que falte algo, y un aviso que aparece por un error de red
     * sería peor que no aparecer: se devuelve 0 y el aviso se queda callado.
     */
    return 0;
  }
}
